import { useTranslation } from "react-i18next"
import { UserAvatarTooltip } from "@/components/avatar-user-tooltip"
import { Card, CardHeader } from "@/components/ui/card"
import { UserProvider } from "@/components/user-wrapper"
import { formatDateString } from "@/lib/format-date"
import { ProgressNoteAndParentData } from "@/modules/patients/detail/progress-note/progress-note-card"

const AdministrativeProgressNoteCard = ({ progressNoteData }: { progressNoteData: ProgressNoteAndParentData }) => {
  const { episodeOfCareProgressNoteData: progressNote } = progressNoteData
  const { t } = useTranslation()
  const {
    id,
    appointment: { service },
    updatedBy,
    createdAt,
  } = progressNote

  return (
    <Card>
      <CardHeader className="gap-4 pl-4">
        <div className="flex items-center gap-4">
          <UserProvider
            userName={updatedBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={id} size="md" />}
          />
          <div className="text-on-surface text-base font-medium">
            {t(`scheduling.waitingRoom.service.${service}`)}
            <div className="text-on-surface-subdued text-xs leading-4 font-normal tracking-[0.25px]">
              {formatDateString(createdAt)}
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  )
}

export { AdministrativeProgressNoteCard }
